export const ROUTES = {
  LANDING: '/',
  LOGIN: '/login',
  VERIFY_EMAIL: '/verify-email',
  AUTH_VERIFY: '/auth/verify',
  ONBOARDING: '/onboarding',
  HOME: '/home',
  
  // Education Section
  AI_TYPING: '/education/ai-typing',
  PROBLEMS: '/education/problems',
  PROBLEM: '/education/problems/:id',
  
  // Sandbox Section
  SANDBOX: '/sandbox',
  SANDBOX_PROJECT: '/sandbox/:mode/:projectId',
  REPOSITORY: '/repository',
  
  // User
  PROFILE: '/profile',
  SETTINGS: '/settings',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  OAUTH_CALLBACK: '/auth/:provider/callback',
  
  // Nova
  NOVA: '/nova',
  NOVA_NOTE: '/nova/:id',

  // Roadmap Section
  CALENDAR: '/roadmap/calendar',
  MY_ROADMAPS: '/roadmap/my-roadmaps',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];

export const buildRoute = {
  problem: (id: string): string => `/education/problems/${id}`,
  sandboxProject: (mode: string, projectId: string): string => `/sandbox/${mode}/${projectId}`,
  verifyEmail: (token: string): string => `/verify-email?token=${token}`,
  resetPassword: (token: string): string => `/reset-password?token=${token}`,
} as const;
